import { Tabs } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import ProfileInfo from "./ProfileInfo"
import PaymentDetails from "./PaymentDetails"
import { ModePreferences } from "./ModePreferences"
import LoginAndSecurity from "./LoginAndSecurity"

const ClientProfileTabs = ({ activeKey, setActiveKey }) => {
  const { t } = useTranslation()

  const items = [
    {
      key: '1',  
      label: t("client.profile.profile_information"),
      children: <ProfileInfo />
    },
    {
      key: '2',  
      label: t("client.profile.payment_details"),
      children: <PaymentDetails />
    },
    {
      key: '3',  
      label: t("client.profile.login_security"),
      children: <LoginAndSecurity />
    },
    {
      key: '4',  
      label: t("client.profile.mode_preferences"),
      children: <ModePreferences />
    }
  ]

  return (
    <Tabs 
      className={styles.clientProfileTabs} 
      defaultActiveKey="1" 
      activeKey={String(activeKey)} 
      onChange={(key) => setActiveKey(Number(key))} 
      items={items} 
    />
  )
}

ClientProfileTabs.propTypes = {
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveKey: PropTypes.func.isRequired
}

export default ClientProfileTabs
